import React, {FC, ReactNode} from "react"

import {H4} from "@irati/ui/src/Typography"
import {StyledHeader, StyledModal} from "./styled"

interface Props {
  children: ReactNode,
  header: ReactNode,
  onClose: () => void
}

const HomepageModal: FC<Props> = ({children, header, onClose}) => (
  <StyledModal
    onExited={onClose}
    onHide={onClose}
    renderHeader={() => (
      <StyledHeader>
        <H4>{header}</H4>
      </StyledHeader>
    )}
    show
    useMobileStyling={false}>
    {children}
  </StyledModal>
)

export default HomepageModal
